import { NgModule } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { CarouselModule } from 'primeng/carousel';
import { MenuModule } from 'primeng/menu';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TreeModule } from 'primeng/tree';
import { MenubarModule } from 'primeng/menubar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SelectButtonModule } from 'primeng/selectbutton';
import {PaginatorModule} from 'primeng/paginator';
import {TriStateCheckboxModule} from 'primeng/tristatecheckbox';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [],
  exports: [
    PanelModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    CarouselModule,
    MenuModule,
    ToastModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    DialogModule,
    RadioButtonModule,
    CheckboxModule,
    TableModule,
    CalendarModule,
    FileUploadModule,
    KeyFilterModule,
    InputTextareaModule,
    TreeModule,
    MenubarModule,
    InputSwitchModule,
    SelectButtonModule,
    PaginatorModule,
    TriStateCheckboxModule,
TooltipModule
  ]
})
export class PrimeModule { }
